import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ProductActiveStockItem } from '../../../../../core/api/products/entities/product-active-stock-item.entity';
import { DashboardService } from '../../../../../core/services/dashboard.service';
import { DashboardActionDialogComponent } from '../dashboard-action-dialog/dashboard-action-dialog.component';

@Component({
  selector: 'app-dashboard-stock-items',
  templateUrl: './dashboard-stock-items.component.html',
  styleUrl: './dashboard-stock-items.component.scss',
})
export class DashboardStockItemsComponent extends DashboardActionDialogComponent {
  columns: string[] = ['rowCreatedAt', 'transactionType', 'amount', 'price'];

  constructor(service: DashboardService) {
    super(service);
  }

  get isSubmitting(): boolean {
    return this.service.state.isSubmitting;
  }

  get stockItems(): MatTableDataSource<ProductActiveStockItem> {
    return new MatTableDataSource(this.service.product?.activeStockItems || []);
  }
}
